import { useMemo } from 'react'

import { useDxtradeInstrumentDetails } from '../Widget/hooks/useDxtradeInstrumentDetails'

interface UseInstrumentLotMetadataResult {
  minLot: number | null
  maxLot: number
  stepLot: number | null
  hasLotMetadata: boolean
}

export const useInstrumentLotMetadata = (
  accountCode: string | undefined,
  symbol: string,
  availableLots: number
): UseInstrumentLotMetadataResult => {
  const { instruments } = useDxtradeInstrumentDetails(accountCode, symbol)

  return useMemo(() => {
    const details = instruments?.[0]
    const rawMin = details?.minOrderSize ?? null
    const rawStep = details?.minOrderSizeIncrement ?? null
    const rawMax = details?.maxOrderSize?.value ?? null

    const available = availableLots > 0 ? availableLots : 0
    const normalizedMaxCandidate = rawMax && rawMax > 0 ? rawMax : available
    const normalizedMax =
      available > 0 ? Math.min(available, normalizedMaxCandidate || available) : available
    const minLot =
      rawMin && rawMin > 0 ? (normalizedMax > 0 ? Math.min(rawMin, normalizedMax) : rawMin) : null
    const stepLot = rawStep && rawStep > 0 ? rawStep : null

    return {
      minLot,
      maxLot: normalizedMax,
      stepLot,
      hasLotMetadata: Boolean(minLot && stepLot),
    }
  }, [instruments, availableLots])
}
